var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 55,
    viewBox: "0 0 57 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1707480261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.1905 7.06876L28.4862 15.7467L19.8082 7.06876V0.500977H12.6602V10.0229L28.4862 25.8489L44.3385 10.0229V0.500977H37.1905V7.06876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.8082 47.661L28.5125 38.9831L37.1905 47.661V54.2288H44.3385V44.7068L28.5125 28.9072L12.6602 44.7068V54.2288H19.8082V47.661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.4325 36.1612L41.7546 27.4569L50.4325 18.7526H57.0003V11.6309H47.4783L31.6523 27.4569L47.4783 43.2829H57.0003V36.1612H50.4325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.56778 18.7526L15.2457 27.4832L6.56778 36.1612H0V43.2829H9.52196L25.3479 27.4832L9.52196 11.6309H0V18.7526H6.56778Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterlogo);
export default __webpack_public_path__ + "static/media/footerlogo.6c17d2b2793e322b2883d0f15e865846.svg";
export { ForwardRef as ReactComponent };